import { checkPageOauth } from '../services'
import goTo from './goTo'
type triggerNodeTypes =
  | 'activtiy'
  | 'section'
  | 'productDetail'
  | 'equityDetail'

/**
 * 检测是否需要授权
 * @param triggerNodeCode
 * @param triggerNode
 * @param redirect
 * @param afterPage
 * @returns
 */
export async function checkOauth(
  triggerNodeCode: string,
  triggerNode: triggerNodeTypes,
  redirect: string,
  afterPage: boolean = false,
) {
  const triggerArea = afterPage ? 'after_entering' : ''
  const res = await checkPageOauth({
    triggerNodeCode,
    triggerNode,
    triggerArea,
  })
  // 是否需要授权
  if (res.needAuthorize) {
    if (afterPage) {
      return {
        needAuthorize: res.needAuthorize,
        callback: () => {
          goTo(
            `/memberEquity/oauth?triggerNodeCode=${triggerNodeCode}&triggerNode=${triggerNode}&triggerArea=${triggerArea}&redirect=${encodeURIComponent(
              redirect,
            )}`,
          )
        },
      }
    } else {
      goTo(
        `/memberEquity/oauth?triggerNodeCode=${triggerNodeCode}&triggerNode=${triggerNode}&redirect=${encodeURIComponent(
          redirect,
        )}`,
        {
          type: 'replace',
        },
      )
    }
    // return Promise.reject()
  } else {
    return Promise.resolve()
  }
}

/** 多语言 intl转为lang */
export function createIntlWrapper(intl: any) {
  const lang = {}
  return new Proxy(lang, {
    get(target: Record<string, any>, prop: any) {
      if (!target[prop]) {
        target[prop] = intl.formatMessage({ id: prop, defaultMessage: prop })
      }
      return target[prop]
    },
  })
}

// 替换小程序前缀
export function wxMiniUrlPrefixReplace(url: string, targetPrefix: string = '') {
  if(url && url.startsWith('weixin://')) {
    url = url.replace('weixin://dl/business/', targetPrefix)
  }
  return url
}
